var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLineAndCircle(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 9,
    viewBox: "0 0 30 9",
    fill: "957EFE",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "nonzero",
    clipRule: "evenodd",
    d: "M16.981 4.02826C16.9758 5.13282 16.0761 6.024 14.9716 6.01878C13.867 6.01355 12.9758 5.11389 12.9811 4.00934C12.9863 2.90478 13.8859 2.0136 14.9905 2.01882C16.095 2.02405 16.9862 2.92371 16.981 4.02826ZM18.8598 4.99992C18.4206 6.74195 16.8393 8.02764 14.9621 8.01875C13.0981 8.00994 11.5379 6.7275 11.1022 4.99992H1C0.447715 4.99992 0 4.5522 0 3.99992C0 3.44764 0.447715 2.99992 1 2.99992H11.112C11.5644 1.2771 13.1363 0.0100274 15 0.0188447C16.8504 0.0275994 18.4014 1.29144 18.8501 2.99992H29C29.5523 2.99992 30 3.44764 30 3.99992C30 4.5522 29.5523 4.99992 29 4.99992H18.8598Z",
    fill: "#957EFE"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLineAndCircle);
export default __webpack_public_path__ + "static/media/lineAndCircle.30c801b7.svg";
export { ForwardRef as ReactComponent };